




import Vue from 'vue'

export default Vue.extend({
  name: 'FormInput',
  props: {
    type: {
      type: String,
      required: true,
      default: 'text'
    },
    placeholder: {
      type: String,
      required: true,
      default: ''
    },
    value: {
      type: String,
      required: true,
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    vvas: {
      type: String,
      required: false,
      default: ''
    },
    validate: {
      type: String,
      required: false,
      default: ''
    }
  },
  methods: {
    handleInput(e: any) {
      this.$emit('input', e.target.value)
    }
  }
})
